interface ProductGalleryProps {
  selectedImage: number;
  setSelectedImage: (index: number) => void;
}

export default function ProductGallery({ selectedImage, setSelectedImage }: ProductGalleryProps) {
  const images = [
    'https://public.readdy.ai/ai/img_res/2aceed236bc16d1dd2231cd78447fb7e.jpg',
    'https://readdy.ai/api/search-image?query=NVIDIA%20GeForce%20RTX%204070%20graphics%20card%20side%20view%20showing%20triple%20fan%20cooling%20system%20and%20metal%20backplate%20on%20pure%20white%20background%2C%20professional%20product%20photography%2C%20high%20detail%2C%20premium%20GPU%20design&width=600&height=600&seq=gpu002&orientation=squarish',
    'https://readdy.ai/api/search-image?query=NVIDIA%20GeForce%20RTX%204070%20graphics%20card%20rear%20IO%20ports%20showing%20DisplayPort%20and%20HDMI%20connectors%20on%20pure%20white%20background%2C%20professional%20product%20photography%2C%20close-up%20detail%20shot&width=600&height=600&seq=gpu003&orientation=squarish',
    'https://readdy.ai/api/search-image?query=NVIDIA%20GeForce%20RTX%204070%20graphics%20card%20installed%20in%20gaming%20PC%20case%20with%20RGB%20lighting%20effects%20on%20pure%20white%20background%2C%20professional%20product%20photography%2C%20gaming%20setup%20showcase&width=600&height=600&seq=gpu004&orientation=squarish'
  ];

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div className="aspect-square bg-gray-50 rounded-2xl overflow-hidden border border-gray-200">
        <img 
          src={images[selectedImage]} 
          alt="NVIDIA GeForce RTX 4070 그래픽카드"
          className="w-full h-full object-contain p-8"
        />
      </div>

      {/* Thumbnail Images */}
      <div className="grid grid-cols-4 gap-4">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`aspect-square bg-gray-50 rounded-lg overflow-hidden border-2 transition-all hover:border-teal-400 cursor-pointer ${
              selectedImage === index ? 'border-teal-600' : 'border-gray-200'
            }`}
          >
            <img 
              src={image} 
              alt={`썸네일 ${index + 1}`}
              className="w-full h-full object-contain p-2"
            />
          </button>
        ))}
      </div>
    </div>
  );
}